var map = {
	"./acquaint-fate.webp": 5483,
	"./close-button.webp": 6001,
	"./constellation-4.webp": 9639,
	"./constellation-5.webp": 4249,
	"./dailies-icon.webp": 685,
	"./details-book.webp": 5084,
	"./intertwined-fate.webp": 3494,
	"./primogem.webp": 2399,
	"./stardust.webp": 6216,
	"./starglitter.webp": 4197,
	"./ui-book-selector.webp": 2035,
	"./ui-inventory.webp": 4417,
	"./ui-quest.webp": 3082,
	"./ui-settings.webp": 3101,
	"./wish-background.webp": 2904,
	"./wish-details-background.webp": 1084,
	"./wish-reveal-background.webp": 1433
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9968;